import dayjs from "@shared/dayjs";

export default (tasksData) => {
  const tasks = [...tasksData];

  tasks.sort((task1, task2) => {
    const time1 = dayjs(task1.due_on).unix();
    const time2 = dayjs(task2.due_on).unix();
    if (time1 > time2) return 1;
    if (time1 < time2) return -1;
    if (task1.assigned_person?.fullName < task2.assigned_person?.fullName) return 1;
    if (task1.assigned_person?.fullName > task2.assigned_person?.fullName) return -1;

    if (task1.priority > task2.priority) return -1;
    return 1;
  });

  return tasks;
};

export const updateDueOn = (contingent, date) => {
  if(!date) return null;

  const {days, position} = contingent

  const originalDate = dayjs(date, "YYYY-MM-DD");
  const newDate = position === 'after' ? originalDate.add(days, 'days') : originalDate.subtract(days, 'days');

  return newDate.format('MM/DD/YY');
};
